/**
 * Iframe Container ID
 * @param id
 */
export function asIframeContainerId(id: string): string {
  return `bs-container-${id}`;
}
